export const ADD_CART = 'ADD_CART';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';
export const INITIALIZE_CART = 'INITIALIZE_CART'